import { useEffect } from 'react';
import { useRecoilState } from 'recoil';
import getQueryParam from 'src/app/utils/getQueryParam';
import { frameParamsAtom } from 'src/app/state/atoms';

/**
 * Hook to get all the information from embeded frame
 * Currently mastering loads Tutor via iframe and passed few information
 * from query parameters.
 *
 * This hook gets all that information and saves in our recoil state
 *
 */

function useFrameParams() {
  const [, setFrameParams] = useRecoilState(frameParamsAtom);

  useEffect(() => {
    setFrameParams({
      exercise_id: getQueryParam('exercise_id') ?? 'test_0',
      book_code: getQueryParam('book_code') ?? '',
      conversation_id: getQueryParam('conversation_id') ?? '',
      // New parameters
      version: getQueryParam('version') ?? undefined,
      correlation: getQueryParam('correlation') ?? getQueryParam('correlation_id') ?? undefined,
      'user-role': getQueryParam('user-role') ?? 'student',
      discipline: getQueryParam('discipline') ?? undefined,
      partner: getQueryParam('partner') ?? getQueryParam('system') ?? undefined,
      course_id: getQueryParam('course_id') ?? undefined,
      login_session_id: getQueryParam('login_session_id') ?? 'NA',
      person_ID: getQueryParam('person_ID') ?? 'NA',
      person_id_type: getQueryParam('person_id_type') ?? 'PI',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}

export default useFrameParams;
